import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const QrIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon {...props} viewBox="0 0 48.054 48.054">
      <path
        id="Path_103"
        data-name="Path 103"
        d="M1.408,10.324A1.408,1.408,0,0,0,2.816,8.916v-6.1h6.1A1.408,1.408,0,1,0,8.916,0H1.408A1.408,1.408,0,0,0,0,1.408V8.916A1.408,1.408,0,0,0,1.408,10.324Z"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_104"
        data-name="Path 104"
        d="M410.916,0h-7.508a1.408,1.408,0,1,0,0,2.816h6.1v6.1a1.408,1.408,0,1,0,2.816,0V1.408A1.408,1.408,0,0,0,410.916,0Z"
        transform="translate(-364.27)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_105"
        data-name="Path 105"
        d="M8.916,409.508h-6.1v-6.1a1.408,1.408,0,1,0-2.816,0v7.508a1.408,1.408,0,0,0,1.408,1.408H8.916a1.408,1.408,0,1,0,0-2.816Z"
        transform="translate(0 -364.27)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_106"
        data-name="Path 106"
        d="M410.916,402a1.408,1.408,0,0,0-1.408,1.408v6.1h-6.1a1.408,1.408,0,1,0,0,2.816h7.508a1.408,1.408,0,0,0,1.408-1.408v-7.508A1.408,1.408,0,0,0,410.916,402Z"
        transform="translate(-364.27 -364.27)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_107"
        data-name="Path 107"
        d="M302.408,75.078H313.67a1.408,1.408,0,0,0,1.408-1.408V62.408A1.408,1.408,0,0,0,313.67,61H302.408A1.408,1.408,0,0,0,301,62.408V73.67A1.408,1.408,0,0,0,302.408,75.078Zm1.408-11.263h8.447v8.447h-8.447Z"
        transform="translate(-272.75 -55.275)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_108"
        data-name="Path 108"
        d="M73.67,301H62.408A1.408,1.408,0,0,0,61,302.408V313.67a1.408,1.408,0,0,0,1.408,1.408H73.67a1.408,1.408,0,0,0,1.408-1.408V302.408A1.408,1.408,0,0,0,73.67,301Zm-1.408,11.263H63.816v-8.447h8.447Z"
        transform="translate(-55.275 -272.75)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_109"
        data-name="Path 109"
        d="M315.078,313.67V302.408a1.408,1.408,0,1,0-2.816,0v9.855h-9.855a1.408,1.408,0,1,0,0,2.816H313.67A1.408,1.408,0,0,0,315.078,313.67Z"
        transform="translate(-272.75 -272.75)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_110"
        data-name="Path 110"
        d="M73.67,61H62.408A1.408,1.408,0,0,0,61,62.408V73.67a1.408,1.408,0,0,0,1.408,1.408H73.67a1.408,1.408,0,0,0,1.408-1.408V62.408A1.408,1.408,0,0,0,73.67,61ZM72.263,72.263H63.816V63.816h8.447Z"
        transform="translate(-55.275 -55.275)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_111"
        data-name="Path 111"
        d="M242.408,75.078a1.408,1.408,0,0,0,1.408-1.408V62.408a1.408,1.408,0,1,0-2.816,0V73.67A1.408,1.408,0,0,0,242.408,75.078Z"
        transform="translate(-218.381 -55.275)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_112"
        data-name="Path 112"
        d="M252.263,242.408A1.408,1.408,0,0,0,250.855,241h-8.447A1.408,1.408,0,0,0,241,242.408V259.3a1.408,1.408,0,0,0,2.816,0V243.816h7.039A1.408,1.408,0,0,0,252.263,242.408Z"
        transform="translate(-218.381 -218.381)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_113"
        data-name="Path 113"
        d="M62.408,243.816h2.816a1.408,1.408,0,1,0,0-2.816H62.408a1.408,1.408,0,1,0,0,2.816Z"
        transform="translate(-55.275 -218.381)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_114"
        data-name="Path 114"
        d="M361,302.408v5.631a1.408,1.408,0,0,0,2.816,0v-5.631a1.408,1.408,0,0,0-2.816,0Z"
        transform="translate(-327.118 -272.75)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_115"
        data-name="Path 115"
        d="M301,302.408v5.631a1.408,1.408,0,1,0,2.816,0v-5.631a1.408,1.408,0,1,0-2.816,0Z"
        transform="translate(-272.75 -272.75)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_116"
        data-name="Path 116"
        d="M395.223,241h-2.816a1.408,1.408,0,1,0,0,2.816h2.816a1.408,1.408,0,0,0,0-2.816Z"
        transform="translate(-354.303 -218.381)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <circle
        id="Ellipse_24"
        data-name="Ellipse 24"
        cx="1"
        cy="1"
        r="1"
        transform="translate(34.532 11.532)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <circle
        id="Ellipse_25"
        data-name="Ellipse 25"
        cx="1"
        cy="1"
        r="1"
        transform="translate(11.532 11.532)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <circle
        id="Ellipse_26"
        data-name="Ellipse 26"
        cx="1"
        cy="1"
        r="1"
        transform="translate(11.532 34.532)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
      <path
        id="Path_117"
        data-name="Path 117"
        d="M155.223,241h-2.816a1.408,1.408,0,1,0,0,2.816h2.816a1.408,1.408,0,1,0,0-2.816Z"
        transform="translate(-136.828 -218.381)"
        fill={props.color ? props.color : theme.palette.primary.light}
      />
    </SvgIcon>
  );
};
